import { accessToken } from '@carvana/core-auth';
import { datadogRum } from '@datadog/browser-rum';
import Cookies from '~/utilities/BrowserCookies';
import getUserId from '~/utilities/getUserId';
import {
  applicationVersion,
  environment,
  isProd
} from './constants/environment';

function log(status: 'imported' | 'initializing' | 'ready') {
  if (isProd) return;

  console.debug(`SRP DataDog is ${status}`, performance.now());
}

log('imported');

export default function initDataDog() {
  log('initializing');

  const isAuthUser = accessToken().isValidToken;

  datadogRum.init({
    applicationId: '12176191-bef0-4c22-ac4f-722c5fa109a6',
    clientToken: 'pubcedfeba7c3e48d9baa9fa8585f4404d3',
    site: 'datadoghq.com',
    service: 'serenity-ui',
    env: environment,
    version: applicationVersion,
    sessionSampleRate: isAuthUser ? 100 : 10,
    sessionReplaySampleRate: isAuthUser ? 100 : 10,
    trackFrustrations: true,
    trackLongTasks: true,
    trackResources: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'allow',
    allowedTracingUrls: [
      'https://apps.carvana.io',
      'https://apik.carvana.io',
      'https://apps.carvanatech.com',
      'https://apik.carvanatech.com'
    ]
  });

  datadogRum.onReady(() => {
    log('ready');
  });

  datadogRum.setUser({
    browserCookieId: Cookies.get('BrowserCookieId'),
    id: getUserId()
  });

  datadogRum.startSessionReplayRecording();
}
